import { defineMessages } from 'react-intl';

export default defineMessages({
  sortByTitle: {
    id: 'global_ordenarpor',
    defaultMessage: 'Sort by',
  },
  filtersTitle: {
    id: 'global_Filters',
    defaultMessage: 'Filters',
  },
  filtersPhotos: {
    id: 'global_filtrofotos',
    defaultMessage: 'With a photo',
  },
  filtersBedrooms: {
    id: 'global_filtrohabitaciones',
    defaultMessage: 'Bedrooms',
    description: 'homes',
  },
  filtersCities: {
    id: 'global_filtrocities',
    defaultMessage: 'Cities',
  },
  filtersRegions: {
    id: 'global_filtroregions',
    defaultMessage: 'Counties',
  },
  filtersArea: {
    id: 'global_filtrosuperficie',
    defaultMessage: 'Floor area',
    description: 'homes',
  },
  filtersBathrooms: {
    id: 'global_filtrobanyos',
    defaultMessage: 'Bathrooms',
    description: 'homes',
  },
  filtersYear: {
    id: 'global_filtroanyo',
    defaultMessage: 'Year',
    description: 'cars',
  },
  filtersMileage: {
    id: 'global_filtrokms',
    defaultMessage: 'Mileage',
    description: 'cars',
  },
  filtersDoors: {
    id: 'global_filtropuertas',
    defaultMessage: 'Number of doors',
    description: 'cars',
  },
  filtersMake: {
    id: 'global_filtromake',
    defaultMessage: 'Make',
    description: 'cars',
  },
  filtersModel: {
    id: 'global_filtromodel',
    defaultMessage: 'Model',
    description: 'cars',
  },
  filtersCarType: {
    id: 'global_filtrocartype',
    defaultMessage: 'Type',
    description: 'cars',
  },
  filtersFuel: {
    id: 'global_filtrofuel',
    defaultMessage: 'Fuel type',
    description: 'cars',
  },
  filtersTransmission: {
    id: 'global_filtrotransmision',
    defaultMessage: 'Transmission',
    description: 'cars',
  },
  filtersDate: {
    id: 'global_filtrofecha',
    defaultMessage: 'Publication date',
  },
  filtersPropertyType: {
    id: 'global_filtrotipoviv',
    defaultMessage: 'Property type',
    description: 'homes',
  },
  filtersCityArea: {
    id: 'global_filtrocityarea',
    defaultMessage: 'District',
  },
  filtersDay: {
    id: 'global_filtrodia',
    defaultMessage: 'Today',
  },
  filtersWeek: {
    id: 'global_filtrosemana',
    defaultMessage: 'filtrosemana',
  },
  filtersClear: {
    id: 'global_delfilters',
    defaultMessage: 'Clear all filters',
  },
  filtersShowResults: {
    id: 'global_filters_show_results',
    defaultMessage: 'Show {%s} results',
  },
  filtersSearching: {
    id: 'global_filters_searching',
    defaultMessage: 'Searching',
  },
  filtersNoMax: {
    id: 'global_sin_maximo',
    defaultMessage: 'No max.',
  },
  filtersNoMin: {
    id: 'global_sin_minimo',
    defaultMessage: 'No min',
  },
  filtersTo: {
    id: 'global_to',
    defaultMessage: 'to',
  },
  filtersPrice: {
    id: 'global_precio',
    defaultMessage: 'Price',
  },
  filtersReduced: {
    id: 'global_decreased_price_ads',
    defaultMessage: 'Reduced price',
  },
  filtersAny: {
    id: 'global_any',
    defaultMessage: 'Any',
  },
  filtersFeatures: {
    id: 'global_propertyFeatures',
    defaultMessage: 'Features',
  },
  filtersParking: {
    id: 'global_parking',
    defaultMessage: 'Parking',
    description: 'homes',
  },
  filtersNewlyBuilt: {
    id: 'global_obra_nueva',
    defaultMessage: 'Newly built',
    description: 'homes',
  },
  filtersFurnished: {
    id: 'search_furnished',
    defaultMessage: 'Furnished',
    description: 'homes',
  },
  filtersSalary: {
    id: 'global_salary',
    defaultMessage: 'Salary',
    description: 'jobs',
  },
  filtersJobCategory: {
    id: 'global_job_category',
    defaultMessage: 'Profession',
    description: 'jobs',
  },
  filtersCompany: {
    id: 'global_company',
    defaultMessage: 'Company',
    description: 'jobs',
  },
  filtersJobType: {
    id: 'global_filtrojobtype',
    defaultMessage: 'Contract type',
    description: 'jobs',
  },
  filtersWorkingHours: {
    id: 'global_filtrojobworkinghours',
    defaultMessage: 'Working hours',
    description: 'jobs',
  },
  filtersExperience: {
    id: 'global_filtroexperience',
    defaultMessage: 'Experience',
    description: 'jobs',
  },
  filtersTelecommute: {
    id: 'global_filter_telecommute',
    defaultMessage: 'Telecommute',
    description: 'jobs',
  },
  locationTitle: {
    id: 'global_filters_location',
    defaultMessage: 'Location',
  },
  popularMakersTitle: {
    id: 'global_serp_popular_makes',
    defaultMessage: 'Popular makers',
    description: 'cars',
  },
  popularModelsTitle: {
    id: 'global_serp_popular_models',
    defaultMessage: 'Popular models of {%4$s}',
    description: 'cars',
  },
  nResults: {
    id: 'global_wm_results',
    defaultMessage: 'results',
  },
  yourSearch: {
    id: 'global_search',
    defaultMessage: 'Your search',
  },
  previousPage: {
    id: 'global_previous',
    defaultMessage: 'Previous',
  },
  nextPage: {
    id: 'global_next',
    defaultMessage: 'Next',
  },
  page: {
    id: 'global_wm_page',
    defaultMessage: 'Page',
  },
  seeMore: {
    id: 'global_see_more',
    defaultMessage: 'See more',
  },
  similarSearches: {
    id: 'global_similar_searches',
    defaultMessage: 'Similar searches',
  },
  closeTo: {
    id: 'global_serp_near_city',
    defaultMessage: 'Near {%3$s}',
  },
  neighborhoodsIn: {
    id: 'global_serp_neighborhood_city',
    defaultMessage: 'Neighborhoods in {%2$s}',
  },
  propertyTypesIn: {
    id: 'global_serp_property_type_in_city',
    defaultMessage: 'Property types in {%3$s}',
    description: 'homes',
  },
  citiesInRegion: {
    id: 'global_serp_cities_in_region',
    defaultMessage: 'Cities in {%1$s}',
  },
  descriptionPriceFrom: {
    id: 'global_meta_description_price_from',
    defaultMessage: 'from {%1$s} pounds',
  },
  descriptionNoPrice: {
    id: 'global_meta_description_no_price',
    defaultMessage: 'at the best price',
  },
  newAdsTitle: {
    id: 'global_new_ads_tab_new_desktop',
    defaultMessage: 'New ads',
  },

  didYouMeanTitle: {
    id: 'global_no_results_message_new_kw',
    defaultMessage: 'Showing results for:',
  },
  noResults: {
    id: 'global_no_results_message_old_kw',
    defaultMessage: 'No results found for <strong>{%s}</strong>',
  },
  jobsTitleWhat: {
    id: 'global_jobs_page_title_what',
    defaultMessage: '{%s} job offers',
    description: 'jobs',
  },
  jobsTitleWhere: {
    id: 'global_jobs_page_title_where',
    defaultMessage: 'Job offers in {%s}',
    description: 'jobs',
  },
  jobsTitleWhatWhere: {
    id: 'global_jobs_page_title_what_where',
    defaultMessage: '{%1$s} job offers in {%2$s}',
    description: 'jobs',
  },
  otherJobCategoriesTitle: {
    id: 'global_serp_other_job_categories',
    defaultMessage: 'Other professions',
    description: 'jobs',
  },
  fewResultsHomesTitle: {
    id: 'global_few_results_homes_title',
    defaultMessage: "We've found this homes you might be interested in",
    description: 'homes',
  },
  fewResultsCarsTitle: {
    id: 'global_few_results_cars_title',
    defaultMessage: "We've found this cars you might be interested in",
    description: 'cars',
  },
  fewResultsJobsTitle: {
    id: 'global_few_results_jobs_title',
    defaultMessage: "We've found this job offers you might be interested in",
    description: 'cars',
  },
});



// WEBPACK FOOTER //
// ./app/Serp/messages.js